<template>
  <footer class="border-top mt-3 py-2 d-none d-sm-flex align-items-center justify-content-end gap-2">
    <i class="cil-globe icon text-body-secondary" />
    <AppLanguageSwitcher />
  </footer>
</template>
